import axios from "axios";

const API = axios.create({
  baseURL: "/api", // change if needed
});

// attach token
API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});

export const createStaffApi = (data) =>
  API.post("/auth/create-staff", data);

export const deactivateUserApi = (id) =>
  API.put(`/auth/deactivate/${id}`);


// ✅ GET STAFF LIST (NEW)
export const getStaffApi = () =>
  API.get("/auth/staff");


// ✅ UPDATE STAFF PASSWORD (NEW)
export const updateStaffPasswordApi = (id, data) =>
  API.put(`/auth/update-password/${id}`, data);